import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ClassSelectionCreate_UpdateSlice = createSlice({
  name: "ClassSelectionCreate_UpdateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ClassSelectionCreate_Update: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successClassSelectionCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureClassSelectionCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearClassSelectionCreate_Update: (state) => {
      state.data = {};
    },
  },
});

export const {
  ClassSelectionCreate_Update,
  failureClassSelectionCreate_Update,
  successClassSelectionCreate_Update,
  clearClassSelectionCreate_Update,
} = ClassSelectionCreate_UpdateSlice.actions;

export default ClassSelectionCreate_UpdateSlice.reducer;
